










import Vue from "vue";

export default Vue.extend({
  name: "ContainerOpener",
  props: {
    label: {
      type: String,
      required: true,
    },
  },
});
